

module.exports = __webpack_require__.stylable.create(
    "Attachment3258848921",
    {"classes":{"root":"Attachment3258848921__root","Attachment":"Attachment3258848921__Attachment","Icon":"Attachment3258848921__Icon","Title":"Attachment3258848921__Title"},"vars":{},"stVars":{"EventTitleColor":"\"fallback(color(--eventTitleColor), fallback(color(--runningTextColor), color(color-5)))\""},"keyframes":{}},
    "",
    16,
    "Attachment3258848921",
    null
);
